import api from "@helpers/api";

import { URLS } from "@constants/urls";

import { ResignationType } from "@type/HRM/resignation";

const apiEndPoint = `${process.env.REACT_APP_RESIGNATION_SERVICE_URL}${process.env.REACT_APP_RESIGNATION_SERVICE_PORT}/${process.env.REACT_APP_RESIGNATION_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/${URLS.RESIGNATIONS}`;

export const getResignation = (() => {
  return async (
    employeeId: number | null,
  ): Promise<{ data: ResignationType }> => {
    return api
      .get(`${apiEndPoint}/${employeeId}`)
      .then((response) => ({ data: response.data }));
  };
})();

export const createResignation = (() => {
  return async (data: {
    data: ResignationType;
  }): Promise<{ data: ResignationType }> => {
    const {
      employeeMasterId,
      resignationsDetailsEmpDocuments,
      resignationsDate,
      unitPositionId,
      letter,
    } = data.data;

    return api
      .post(apiEndPoint, {
        employeeMasterId: employeeMasterId,
        unitPositionId,
        resignationsDate,
        resignationsDetailsEmpDocuments,
        letter,
      })
      .then((response) => ({ data: response.data }));
  };
})();
